import React from 'react';
import ReactDOM from 'react-dom/client';
import "./global.css"
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from 'utils/AuthContext';
import "react-toggle/style.css"
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-circular-progressbar/dist/styles.css';
import "react-country-state-city/dist/react-country-state-city.css";
import 'react-international-phone/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'rc-time-picker/assets/index.css';
import 'react-tagsinput/react-tagsinput.css';
import "react-big-calendar/lib/css/react-big-calendar.css";
import "gantt-task-react/dist/index.css";
import { registerLicense } from '@syncfusion/ej2-base';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { SocketProvider } from 'utils/SocketContext';
registerLicense('Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH5feHRXRWVfVkF/W0I=');
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AuthProvider>
    <SocketProvider>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <ToastContainer />
      <App />
    </GoogleOAuthProvider>
    </SocketProvider>
    </AuthProvider>
  </BrowserRouter>

);

